/**
* @brandOverride URBNWeb
*/

import { decodeClientData } from '../../../core/js/utils/decodeUtils';

export const categoryInitialState = {
    // eslint-disable-next-line angular/window-service
    category: decodeClientData(window.categoryData).category || {},
    product: {},
    registry: {}
};

export default categoryInitialState;
